import $ from "jquery";
import growl from "utils/growl";
import i18n from "utils/i18n";

/**
 * The global error handler for common errors coming from jQuery ajax calls.
 *
 * @param {object} event The ajax event
 * @param {object} jqxhr The jQuery XHR object
 * @param {object} settings The request settings
 * @param {string} thrownError The jQuery ajax error string
 */
export function onAjaxError(event, jqxhr, settings, thrownError) {
  // Don't handle the error if a custom error handler is defined in settings
  if (settings.error != null) {
    return;
  }

  // Aborted AJAX calls aren't really errors
  if (thrownError === "abort") {
    return;
  }

  switch (jqxhr.status) {
    case 401:
      growl.sessionExpired();
      break;
    case 402:
      growl.alert(i18n.t("global.error_disabled_html"), { delay: 20000 });
      break;
    case 403:
      growl.alert(i18n.t("global.error_forbidden_html"), { delay: 20000 });
      break;
    default:
      growl.error();
  }
}

$(document).ajaxError(onAjaxError);
